import { isRunningInAppLikeContext, isRunningInTWA } from '~/utils/browserInfo';
import { isProduction } from '~/utils/template';
import { useAuthStore } from '~/stores/auth';
import { useUserDataStore } from '~/stores/userData';

export default defineNuxtPlugin(() => {
  if (!isProduction()) {
    return;
  }

  const debounce = (func: Function, delay: number) => {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function (...args: any[]) {
      if (timeout) {
        return;
      }

      timeout = setTimeout(() => {
        func(...args);
        timeout = null;
      }, delay);
    };
  };

  const config = useRuntimeConfig();
  const authStore = useAuthStore();
  const { isAuthenticated } = storeToRefs(authStore);
  const userDataStore = useUserDataStore();
  const { user } = storeToRefs(userDataStore);

  const debouncedSendWebhook = debounce(async (payload: any) => {
    try {
      await $fetch(config.public.n8nWebhookUrl, {
        method: 'POST',
        body: payload,
      });
    } catch (error) {
      console.error('Falha ao enviar o webhook para o n8n:', error);
    }
  }, 5000);

  watchEffect(() => {
    if (!isAuthenticated.value || !user.value) {
      return;
    }

    const isTwa = isRunningInTWA();
    const referrer = document.referrer;
    // O campo `is_pwa` mantém nome e valor (ENG-843): renomear quebraria a
    // série no BI. Mas ele NÃO mede PWA — é true para o app RN, Instagram e
    // Facebook, porque o detector pega qualquer WKWebView.
    const isAppLike = isRunningInAppLikeContext();

    const payload = {
      referrer,
      is_pwa: isAppLike,
      is_twa: isTwa,
      user_id: user.value.id,
    };

    debouncedSendWebhook(payload);
  });
});
